export const BUSINESS_TRAVELLER_ROOT_ROUTE = '/'

// Login (dedicated app/mobile login page)
export const BUSINESS_TRAVELLER_LOGIN_ROUTE = '/login'

// svc-auth redirects here after the authorize step. Allowlisted region-less
// (`${origin}/oidc-callback`); the region prefix is added on hydration.
export const BUSINESS_TRAVELLER_OIDC_CALLBACK_ROUTE = '/oidc-callback'

// Business signup
export const BUSINESS_TRAVELLER_BUSINESS_SIGNUP_ROUTE = '/business-signup'
export const BUSINESS_TRAVELLER_BUSINESS_SIGNUP_COMPLETE_ROUTE = '/business-signup-complete'
// Employee setup
export const BUSINESS_TRAVELLER_EMPLOYEE_SETUP_ROUTE = '/employee-setup'
// Order Approval Page
export const BUSINESS_TRAVELLER_APPROVE_ORDER_ROUTE = '/approve-order/:approveRequestId'
export const BUSINESS_TRAVELLER_FAQ_ROUTE = '/frequently-asked-questions'
export const BUSINESS_TRAVELLER_EXPRESSION_OF_INTEREST_ROUTE = '/expression-of-interest'

// My Approvals Page
export const BUSINESS_TRAVELLER_MY_APPROVALS_ROUTE = '/my-approvals'
export const BUSINESS_TRAVELLER_MY_APPROVALS_PENDING_ROUTE = '/my-approvals/pending'
export const BUSINESS_TRAVELLER_MY_APPROVALS_HISTORY_ROUTE = '/my-approvals/history'

export const BUSINESS_TRAVELLER_MY_APPROVALS_VIEW_ROUTE = '/my-approvals'

// My Trip Requests Page
export const BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ROUTE = '/my-trip-requests'
export const BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ACTIVE_ROUTE = '/my-trip-requests/active'
export const BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_HISTORY_ROUTE = '/my-trip-requests/history'

export const BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_VIEW_ROUTE = '/my-trip-requests'

// Policy page
export const BUSINESS_TRAVELLER_POLICY_ROUTE = '/privacy-policy'

// Booking & refund policy page
export const BUSINESS_TRAVELLER_BOOKING_POLICIES_ROUTE = '/booking-policies'

// Terms and conditions page
export const BUSINESS_TRAVELLER_TERMS_AND_CONDITIONS_ROUTE = '/terms-and-conditions'

export const BUSINESS_TRAVELLER_SUPPORT_HEADER_ROUTES = [
  `/:regionCode${BUSINESS_TRAVELLER_BUSINESS_SIGNUP_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_BUSINESS_SIGNUP_COMPLETE_ROUTE}`,
]

export const BUSINESS_TRAVELLER_SALES_LANDING_ROUTE = '/:regionCode'

export const BUSINESS_TRAVELLER_NO_HEADER_ROUTES = [
  `/:regionCode${BUSINESS_TRAVELLER_EMPLOYEE_SETUP_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_LOGIN_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_OIDC_CALLBACK_ROUTE}`,
]

export const BUSINESS_TRAVELLER_NO_FOOTER_ROUTES = [
  `/:regionCode${BUSINESS_TRAVELLER_BUSINESS_SIGNUP_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_BUSINESS_SIGNUP_COMPLETE_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_EMPLOYEE_SETUP_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_LOGIN_ROUTE}`,
  `/:regionCode${BUSINESS_TRAVELLER_OIDC_CALLBACK_ROUTE}`,
]

/**
 * Pages that show the white label app's bottom tab bar
 */
export const MOBILE_APP_BOTTOM_NAV_ROUTES: Array<string> = [
  // Search
  `/:regionCode${BUSINESS_TRAVELLER_ROOT_ROUTE}`,
  '/:regionCode/search',
  '/:regionCode/search/car-hire',
  '/:regionCode/flights-search-results',
  '/:regionCode/flights-search-results-multi-city',
  // Bookings
  '/:regionCode/account/my-bookings/:tab(upcoming|cancelled|past|active-trip-requests)?',
  // Trip requests and approvals
  `/:regionCode${BUSINESS_TRAVELLER_MY_TRIP_REQUESTS_ROUTE}/:tab(active|history)?`,
  `/:regionCode${BUSINESS_TRAVELLER_MY_APPROVALS_ROUTE}/:tab(pending|history)?`,
  // Account
  '/:regionCode/account',
  '/:regionCode/account/details',
  '/:regionCode/account/details/traveller',
  '/:regionCode/account/credits-payments',
  '/:regionCode/account/travel-preferences',
  '/:regionCode/account/travel-companions',
]

/**
 * Pages where the app bottom nav paints a solid background instead of floating over the content
 */
export const MOBILE_APP_BOTTOM_NAV_SOLID_BACKGROUND_ROUTES = [
  '/:regionCode/flights-search-results',
  '/:regionCode/flights-search-results-multi-city',
  '/:regionCode/account/details',
]

/**
 * Pages that show no header at all in the white label app
 */
export const MOBILE_APP_NO_HEADER_ROUTES: Array<string> = [
  ...MOBILE_APP_BOTTOM_NAV_ROUTES,
  '/:regionCode/booking/confirmation',
  '/:regionCode/bb/booking/confirmation',
]
